/* eslint-disable react/jsx-props-no-spreading */

/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { TextInput } from '@ui/molecules/inputs';`
 * Or: `import { TextInput } from '@ui/molecules/inputs/form';`
 *
 * Or specific path: `import { TextInput } from '@ui/molecules/inputs/form/TextInput';`
 *
 * See the new component for documentation and migration notes.
 */
import React from 'react';
import PropTypes from 'prop-types';
import './TextInput.scss';
import clsx from 'classnames';

const TextInput = React.forwardRef(({ id, type, label, required, error, ...props }, ref) => {
  return (
    <div className={clsx('qmb-input textInputContainer', { 'has-error': error })}>
      <input id={id} ref={ref} type={type} {...props} />
      <label htmlFor={id} className={clsx('qmb-label', { '--required': required })}>
        {label}
      </label>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
});

TextInput.displayName = 'TextInput';

export default TextInput;

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string
};

TextInput.defaultProps = {
  onChange: () => {},
  value: '',
  label: '',
  type: 'text',
  required: false,
  error: null
};
